import React, { useContext } from "react";
import { AppContext } from "../App";
import LangSelector from "./LangSelector";
import HamburgerIcon from "../icons/HamburgerIcon";
import SearchIcon from "../icons/SearchIcon";
import CollapseMenuIcon from "../icons/CollapseMenuIcon";

function Header() {
	const {
		setMenuVisible,
		menuVisible,
		list,
		shop,
		settings,
		course,
		setCourse,
		courses,
		category,
		setCategory,
		setSearchVisible,
		getTranslatedString,
	} = useContext(AppContext);
	const menuSettings = settings?.menu;
	const enableCategoriesView = menuSettings?.enable_categories_view == 1;
	const hasMacroCategories = courses && courses.length > 1;
	const firstAvailableCategory = courses?.find((el) => el.categories?.length > 0)?.categories?.[0];
	const showTopBack =
		shop &&
		list &&
		enableCategoriesView &&
		menuSettings?.categories_menu_type == 2 &&
		(category || (hasMacroCategories && course));

	return (
		<>
			<div className="header">
				<div className="left">
					{shop && list && menuSettings?.categories_menu_type == 1 && (
						<button className="button" onClick={() => setMenuVisible(!menuVisible)}>
							{menuVisible ? (
								<CollapseMenuIcon></CollapseMenuIcon>
							) : (
								<HamburgerIcon></HamburgerIcon>
							)}
						</button>
					)}
					{shop && list && (
						<button className="button" onClick={() => setSearchVisible(true)}>
							<SearchIcon></SearchIcon>
						</button>
					)}
					{showTopBack && (
						<button
							className="button"
							onClick={() => {
								if (category) setCategory(false);
								else if (hasMacroCategories && course) setCourse(false);
							}}
						>
							<span aria-hidden="true">←</span>
						</button>
					)}
				</div>
				<button
					className="logo"
					onClick={() => {
						if (
							menuSettings?.categories_menu_type == 1 &&
							!enableCategoriesView &&
							firstAvailableCategory
						) {
							setCategory(firstAvailableCategory);
							return;
						}
						setCategory(false);
						if (hasMacroCategories) setCourse(false);
					}}
				>
					{menuSettings?.logo && <img src={menuSettings.logo} />}
				</button>
				<div className="right">
					<LangSelector />
				</div>
			</div>
			{list?.description && list.description != "" && (
				<div className="subheader">{getTranslatedString(list, "description")}</div>
			)}
		</>
	);
}

export default Header;
